const {
    aliasesFilepath,
    assetsDomain,
    webApiDomain,
    brandDefaultLanguage,
} = window.spectateConfig;

export const getAliasesFilepath = () => aliasesFilepath;
export const getAssetsDomain = () => assetsDomain;
export const getWebApiDomain = () => webApiDomain;
export const getBrandDefaultLanguage = () => brandDefaultLanguage;
